import React from 'react'
import Autocompete from './Autocompete'
import './JobProcess.css'
import './JobInfo.css'
import { Link } from 'react-router-dom'
import JobHeader from './JobHeader'
import SideBar from './SideBar'
export default function JobInfo() {
  return (
    <> 
    <JobHeader/>
    <div class ="jobProcess">
        <SideBar/>
    <div class ="job-info">
   
<h1>Job Details</h1>
      <div className="field-hd"> Job Posting Title <span className="mandatory">*</span></div>
      <br />
      <input type="text" className="text_name"/>
      <br />
      <div className="field-hd"> Justification <span className="mandatory">*</span> </div><br />
      <textarea cols={50} rows={5}>
      </textarea>
      
      <br/>
    
      <div className="field-hd">Job Profiles <span className="mandatory">*</span></div>  <Autocompete/> <br/>
     
      <div className="field-hd">Additional Job Profiles <span className="mandatory">*</span></div> <Autocompete/>
      <br />
      <div className="field-hd">Job description Summary</div>
      <br />
      <textarea cols={50} rows={5}>
      </textarea>
      <br />
    </div> </div>
    <div className='next-bar'>
                        <Link to="#">  <button className='back-btn'>Cancel</button></Link>
                        <Link to="/org"> <button className='next-btn'>Next</button></Link>
          
        </div>
    </>
  )
}